interface GrowthIconProps {
  className?: string;
}

const GrowthIcon = ({ className = '' }: GrowthIconProps) => (
  <svg
    width='30'
    height='31'
    viewBox='0 0 30 31'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <rect y='0.841553' width='30' height='30' rx='15' fill='#DEFAFA' />
    <path
      d='M22.8031 11.2278L17.8457 16.5867'
      stroke='#075C5C'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.2449 16.5815L14.5225 14.857'
      stroke='#075C5C'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.8869 14.8839L9.22363 18.5502'
      stroke='#075C5C'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.9766 11.2278H22.8038V14.0591'
      stroke='#075C5C'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14.8435 14.0593C14.8442 13.4225 14.3289 12.9056 13.6926 12.905C13.0563 12.9043 12.54 13.42 12.5393 14.0569C12.5386 14.6937 13.0539 15.2106 13.6902 15.2112C14.3265 15.2119 14.8428 14.6962 14.8435 14.0593Z'
      stroke='#075C5C'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.0427 18.5666C17.679 18.5666 18.1948 18.0503 18.1948 17.4134C18.1948 16.7766 17.679 16.2603 17.0427 16.2603C16.4064 16.2603 15.8906 16.7766 15.8906 17.4134C15.8906 18.0503 16.4064 18.5666 17.0427 18.5666Z'
      stroke='#075C5C'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.50169 19.3022C9.50236 18.6653 8.98709 18.1485 8.3508 18.1478C7.71452 18.1472 7.19816 18.6629 7.1975 19.2998C7.19683 19.9366 7.7121 20.4534 8.34839 20.4541C8.98467 20.4548 9.50103 19.939 9.50169 19.3022Z'
      stroke='#075C5C'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default GrowthIcon;
